var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarCheckWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.81055 2.00003V4.85003M11.5105 2.00003V4.85003M15.073 10.55V4.85003C15.073 4.4721 14.9229 4.10964 14.6557 3.8424C14.3884 3.57516 14.026 3.42503 13.648 3.42503H3.67305C3.29511 3.42503 2.93266 3.57516 2.66542 3.8424C2.39818 4.10964 2.24805 4.4721 2.24805 4.85003V14.825C2.24805 15.203 2.39818 15.5654 2.66542 15.8327C2.93266 16.0999 3.29511 16.25 3.67305 16.25H9.37305M2.24805 7.70003H15.073M11.5105 14.825L12.9355 16.25L15.7855 13.4",
    stroke: "white",
    strokeWidth: 1.425,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarCheckWhite);
export default __webpack_public_path__ + "static/media/calendar-check-white.364cc7a14a653334bc72b00731edbc90.svg";
export { ForwardRef as ReactComponent };